/**
 * @owner @Appboy/whats-app
 * WhatsApp Carousel Response Card Schema
 *
 * Card-level schema for carousel *response* messages (whats_app_message_type = "response").
 * Distinct from whatsAppCarouselCardSchema, which covers carousel *template* liquid variables.
 */

import { z } from "zod";
import { common } from "@schemas/common";

// refer to WhatsAppCarouselResponseCard
export const whatsAppResponseCarouselCardSchema = z.object({
  // At least one of media_uri/asset_id is required (see CarouselResponseCard#content_validations).
  media_uri: z.string().nullable().optional(),
  asset_id: common.objectId.nullable().optional(),
  // Restricted to image/video only (see CarouselResponseCard::CAROUSEL_VALID_MEDIA_TYPES), unlike the
  // full whatsAppMediaTypeSchema enum supported by the media layout.
  media_type: z.enum(["i", "v"]),
  body_text: z.string().nullable().optional(),
  // Present when the carousel's carousel_button_type is "quick-reply"; mutually exclusive with cta_url_button.
  buttons: z.array(z.string()).optional(),
  // Present when the carousel's carousel_button_type is "url"; mutually exclusive with buttons.
  cta_url_button: z
    .object({
      display_text: z.string().nullable().optional(),
      url: z.string().nullable().optional(),
    })
    .optional(),
});
